<app-dashboard-box>
  <app-table
    [tableRows]="alarmTableRows"
    [tableConfig]="alarmTableConfig" />
</app-dashboard-box>

<app-dialog-base [class.open]="isAlarmDetailOpen"
                 (outSideClick)="closeAlarmDetailDialog()"
                 iconLeft="notification_important"
                 [buttonAction]="closeAlarmDetailDialog"
                 [title]="('dialogs.alarm.detail' | translateSafe: {
                  name: (alarmDetailDialogName | translateSafe)
                 })">

  <dialog-alarm-detail [alarm]="selectedAlarm"
                       [loading]="alarmStatusLoading"
                       (statusAction)="onAlarmStatusAction($event)"
                       (closeClick)="closeAlarmDetailDialog()" />
</app-dialog-base>
